import {athubAxios} from '../../util'
import {RestResource} from '../rest'
import {ATTACHMENT_SERVER} from '../server'

const attachment = new RestResource({server: ATTACHMENT_SERVER, resource: 'file'});

attachment.upload = (params) => {

    return new Promise((resolve, reject) => {
        let url = `${ATTACHMENT_SERVER}/file/upload/${params.ownerTable}/${params.docType}/${params.ownerId}`;
        athubAxios.postByMultipartForm(url, params).then(responseBody => {
            if (responseBody.status == 200 && responseBody.data.code == 'OK') {
                resolve(responseBody.data.list);
            }else{
                reject(responseBody.data);
            }
        }).catch(error => {
            reject(error);
        });
    });

}

attachment.downloadList = (params) => {

    return new Promise((resolve, reject) => {
        let url = `${ATTACHMENT_SERVER}/file/${params.ownerTable}/${params.ownerId}`;
        athubAxios.get(url).then(responseBody => {
            if (responseBody.status == 200 && responseBody.data.code == 'OK') {
                let attachmentArr = [];
                responseBody.data.list.forEach(element => {
                    url = `${ATTACHMENT_SERVER}/` + element.URL + "&appId=WEB" + "&token=" + localStorage.getItem("token");
                    attachmentArr.push({
                        'name': element.description,
                        'url': url,
                        'docLinkSid': element.docLinkSid,
                        'createBy': element.CREATEBY,
                        'createByRealName': element.CREATEBYREALNAME,
                        'createDate': element.CREATEDATE,
                    });
                });
                resolve(attachmentArr);
            }
        }).catch(error => {
            reject(error);
        });
    });

}

attachment.delete = (docLinkSid) => {

    return new Promise((resolve, reject) => {
        let url = `${ATTACHMENT_SERVER}/file/${docLinkSid}`;
        athubAxios.delete(url).then(responseBody => {
            if (responseBody.status == 200 && responseBody.data.result == 'OK') {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });

}

attachment.downloadFile = (url, filename) => {
    athubAxios.download(`${ATTACHMENT_SERVER}/${url}`, filename);
};

export default attachment;